module.exports = __webpack_public_path__ + "static/img/present.b06ed30.png";


//////////////////
// WEBPACK FOOTER
// ./static/portal/present.png
// module id = 1180
// module chunks = 18